/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cons from 'Constant';
import BottomLine from '@/components/BottomLine';
export default {
  props: {
    loadStatus: {
      type: Number
    }
  },
  components: {
    BottomLine: BottomLine
  },
  data: function data() {
    return {};
  }
};